/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useMemo, useEffect, useContext } from 'react';
import { faTruckFast } from '@fortawesome/free-solid-svg-icons';
import {
  Card,
  Form,
  FormControl,
  InputGroup,
  Collapse,
  Row
} from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/base/Button';
import PaymentPinModal from './PaymentPinModal';
import fetchData from 'services/fetchData';
import { AuthContext } from 'context/AuthContext';
import postData from 'services/postData';
import Icon from 'components/icon';
import ScanQrCodeModal from './ScanQrCodeModal';
import CustomAlert from 'components/alerts/CustomAlert';
import { areStringsEqual } from 'services/utils';
import { Col } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import IconButton from 'components/custom/ui/IconButton';
import LoadingButton from 'components/custom/animate-component/LoadingButton';
import apiEndpoints from 'constants/apiEndpoints';
import ChangeDriverForChallans from './ChangeDriverForChallans';

const TruckNoField = React.memo(
  ({
    hideNumber,
    showDriver,
    values,
    errors,
    setFieldError,
    handleChange,
    handleBlur,
    touched,
    verifyTruck,
    truckLoading,
    resetData
  }) => {
    return useMemo(() => {
      if (!hideNumber) {
        return (
          <div className="mb-2">
            <p className="mb-0 fs-9  text-600">Vehicle Number :</p>
            <Form.Group className="w-100" controlId="truckNumber">
              <InputGroup className="">
                <FormControl
                  value={values.truckNumber}
                  onChange={e => {
                    if (errors.truckNumber) {
                      setFieldError('truckNumber', '');
                    }
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                  disabled={showDriver}
                  isInvalid={touched.truckNumber && errors.truckNumber}
                  placeholder="Enter Vehicle Number"
                  // autoFocus
                  aria-label="voucher"
                />
                {/* <Form.Control.Feedback
                    style={{ borderRadius: '0.25rem' }}
                    type="invalid"
                    tooltip
                  >
                    {errors.truckNumber}
                  </Form.Control.Feedback> */}
                <LoadingButton
                  idClass={'truckNumber'}
                  size="sm"
                  disabled={values.truckNumber?.length === 0}
                  variant={`${showDriver ? 'success' : 'phoenix-primary'}`}
                  onClick={verifyTruck}
                  className="px-5"
                  style={{ pointerEvents: showDriver ? 'none' : 'all' }}
                  primaryText={showDriver ? 'Verified' : 'Verify'}
                  loadingText={'Verifying...'}
                  isLoading={truckLoading}
                />
              </InputGroup>
            </Form.Group>
            {showDriver ? (
              <Button
                variant="link"
                size="sm"
                onClick={resetData}
                className="p-0 pt-1 ps-1 fs-10 fw-normal"
              >
                Change vehicle number
              </Button>
            ) : null}
          </div>
        );
      } else {
        return null;
      }
    }, [showDriver, values, errors, touched, truckLoading]); // Memoize based on relevant props
  }
);

const validationSchema = Yup.object().shape({
  amount: Yup.number()
    // .min(0, 'Amount must be greater than 0')
    .test(
      'max-amount',
      'Amount must not exceed allowed limit',
      function (value) {
        const { driver_advance } = this.parent;
        if (driver_advance == null) {
          return value <= 10000;
        }
        return value <= driver_advance;
      }
    )
    .required('Amount is required')
    .test('decimal-places', 'Amount must have up to 2 decimal places', value =>
      /^\d+(\.\d{1,2})?$/.test(value)
    ),
  truckNumber: Yup.string().required('Please enter Vehicle number'),
  challanNo: Yup.string()
    .min(4, 'Challan no must be at least 4 characters long')
    .required('Please enter challan number'),
  upiNumber: Yup.string().required('Please enter UPI number')
});

const QuickPaymentView = ({
  defaultData = {},
  payURL = 'quick_payment/create_quick_pay',
  transFor = 'Other',
  minWidth = '400px',
  hideNumber = false,
  amountIsEditable = true,
  refreshData = () => {},
  reFetchChallanData = () => {},
  paymentCallback
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedDriver, setSelectedDriver] = useState('');
  const [payMode, setPayMode] = useState('');
  const [truckDetail, setTruckDetail] = useState({});
  const [showDriver, setShowDriver] = useState(false);
  const [showTruckError, setShowTruckError] = useState(false);
  const [showPin, setShowPin] = useState('');
  const [openQr, setQrOpen] = useState(false);
  const [truckLoading, setTruckLoading] = useState(false);
  const [upiLoading, setUpiLoading] = useState(false);
  const [upiVerified, setUpiVerified] = useState(false);
  const [isDifferentName, setIsDifferentName] = useState(false);
  const [openChangeDriver, setOpenChangeDriver] = useState(false);

  const amtRef = useRef('');
  const upiRef = useRef('');
  const challanRef = useRef('');
  const { user } = useContext(AuthContext);
  const {
    driver_advance,
    driver_mobile,
    driver_name,
    driver_upi_id,
    driver_upi_name,
    challan_no,
    vehicle_number,
    driver_id
  } = defaultData || {};
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    resetForm,
    setFieldError,
    setValues
  } = useFormik({
    initialValues: {
      amount: driver_advance || '',
      driver_advance: driver_advance || '',
      driver_name: driver_name || '',
      driver_phone: driver_mobile || '',
      truckNumber: vehicle_number || '',
      challanNo: challan_no || '',
      upiNumber: driver_upi_id || '',
      upiName: driver_upi_name || '',
      driver_id: driver_id || ''
    },
    validationSchema: validationSchema,
    validateOnMount: true,
    onSubmit: values => {
      console.log('Form submitted with values:', values);
    }
  });
  useEffect(() => {
    if (Object.keys(defaultData || {}).length > 0) {
      // setTimeout(() => {
      //   verifyTruck();
      // }, 300);
      setValues({
        amount: defaultData.driver_advance || 0,
        driver_advance: defaultData.driver_advance || '',
        driver_name: defaultData.driver_name || '',
        driver_phone: defaultData.driver_mobile || '',
        truckNumber: defaultData.vehicle_number || '',
        challanNo: defaultData.challan_no || '',
        upiNumber: defaultData.driver_upi_id || '',
        upiName: defaultData.driver_upi_name || '',
        driver_id: defaultData.driver_id || ''
      });
      setTruckDetail(defaultData);
      setShowDriver(true);
      if (driver_upi_id) {
        setUpiVerified(true);
      }
      if (driver_upi_name && driver_name) {
        setIsDifferentName(!areStringsEqual(driver_name, driver_upi_name));
      }
    }
  }, [defaultData]);

  const verifyTruck = async () => {
    setTruckLoading(true);
    const truck = await fetchData(
      apiEndpoints.QuickPayment.getQuickPay(values.truckNumber)
    );
    // const truck = await fetchData(`get_truck?vehicleno=${values.truckNumber}`);

    if (truck.status) {
      setTruckDetail(truck.data);
      setTruckLoading(false);
      setShowDriver(true);
      setFieldValue('driver_id', truck.data.driver_id);
      setFieldValue('upiNumber', truck.data.driver_upi_id);
      setFieldValue('upiName', truck.data.driver_upi_name);
      if (truck.data.driver_upi_id) {
        setUpiVerified(true);
      }
      setFieldValue('driver_name', truck.data.driver_name);
      setFieldValue('driver_phone', truck.data.driver_mobile);
      if (truck.data.driver_upi_name && truck.data.driver_name) {
        setIsDifferentName(
          !areStringsEqual(truck.data.driver_name, truck.data.driver_upi_name)
        );
      }
      setTimeout(() => {
        challanRef?.current?.focus();
      }, 100);
    } else {
      // alert('No truck found');
      setShowTruckError(true);
      setFieldError('truckNumber', 'Vehicle not found');
      setTruckLoading(false);
    }
  };

  const verifyUpi = () => {
    setUpiLoading(true);
    setTimeout(() => {
      setUpiLoading(false);
      setUpiVerified(true);
      upiRef?.current?.focus();
    }, 2000);
  };

  useEffect(() => {
    if (showDriver) {
      setTimeout(() => {
        amtRef?.current?.focus();
      }, 500);
    }
  }, [showDriver]);

  useEffect(() => {
    if (selectedDriver) {
      setShowDriver(true);
    }
  }, [selectedDriver]);

  const resetData = () => {
    resetForm();
    setPayMode('');
    setShowDriver(false);
    setShowPin(false);
    setUpiVerified(false);
    setTruckDetail({});
    setTruckLoading(false);
    setUpiLoading(false);
    setIsDifferentName(false);
  };
  console.log(values.amount, 'alues.amount');
  const proceedPayment = async ({ pin, latitude, longitude }, callback) => {
    const paymentPostData = {
      driver_upi_id: values.upiNumber,

      trans_by: user.user_id,
      transaction_pin: pin,
      challan_no: values.challanNo,
      challan_number: values.challanNo,
      trans_type: payMode,
      amount: parseInt(values.amount),

      upi_id: values.upiNumber,
      driver_upi_name: values.upiName,
      vehicle_number: values.truckNumber,
      driver_id: values.driver_id,
      driver_name: values.driver_name,
      driver_mobile: values.driver_phone,

      trans_for: transFor,
      latitude: latitude,
      longitude: longitude
    };

    const requestPayment = await postData(paymentPostData, payURL);
    callback(requestPayment);
  };

  const setUPIData = ({ payeeId, payeeName }) => {
    setFieldValue('upiNumber', payeeId);
    setFieldValue('upiName', payeeName);
    setTruckDetail(pre => ({
      ...pre,
      driver_upi_id: payeeId,
      driver_upi_name: payeeName
    }));
    if (payeeName && values['driver_name']) {
      setIsDifferentName(!areStringsEqual(payeeName, values['driver_name']));
    }
    setUpiVerified(true);
  };

  const handleParams = type => {
    if (type === 'add') {
      searchParams.set('pinModal', 'open');

      // Update the browser URL without reloading the page
      setSearchParams(searchParams);
    } else if (type === 'remove') {
      searchParams.delete('pinModal');
      // Update the browser URL without reloading the page
      setSearchParams(searchParams);
    }
  };

  const handlePinModal = mode => {
    setPayMode(mode);
    handleParams('add');
    setShowPin(true);
  };

  const handleClosePinModal = () => {
    setShowPin(false);
    setPayMode('');
    handleParams('remove');
  };

  const handleChangeDriver = () => {
    setOpenChangeDriver(true);
  };

  console.log('🚀 ~ errors.amount:', errors.amount);
  return (
    <>
      <Card style={{ maxWidth: minWidth, width: '100%' }}>
        {!hideNumber ? (
          <Card.Header className="bg-100 pt-3 pb-3 d-flex justify-content-center border-bottom-0">
            <h4
              className="mb-0 text-center border-bottom border-2 border-dark"
              style={{ width: 'max-content' }}
            >
              <span>Quick Payment</span>
              <FontAwesomeIcon
                icon={faTruckFast}
                className="ms-1"
                style={{ marginBottom: '-2px' }}
              />{' '}
            </h4>
          </Card.Header>
        ) : null}
        <Card.Body className={`${hideNumber ? 'p-2' : ''}`}>
          <TruckNoField
            hideNumber={hideNumber}
            showDriver={showDriver}
            values={values}
            errors={errors}
            setFieldError={setFieldError}
            handleChange={handleChange}
            handleBlur={handleBlur}
            touched={touched}
            verifyTruck={verifyTruck}
            truckLoading={truckLoading}
            resetData={resetData}
          />
          {/* Fct> */}
          <Collapse in={showDriver || hideNumber}>
            <div className="mb-3">
              <Row>
                <Col xs={12} md={6} className="pe-md-1">
                  <div className="">
                    <p className="mb-1 fs-9 text-600">Driver Name :</p>
                    <Form.Group>
                      <Form.Control
                        disabled
                        className="w-100"
                        type="text"
                        value={values.driver_name}
                      ></Form.Control>
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} md={6} className="ps-md-1">
                  <div className="">
                    <p className="mb-1 fs-9  text-600">Driver Mobile No :</p>
                    <Form.Group>
                      <Form.Control
                        fullwidth
                        disabled
                        type="text"
                        value={values.driver_phone}
                      ></Form.Control>
                    </Form.Group>
                  </div>
                </Col>
                <Col xs={12} className="mb-2">
                  {transFor !== 'Other' ? (
                    <Button
                      variant="link"
                      size="sm"
                      onClick={handleChangeDriver}
                      className="p-0 pt-0 ps-1 fs-10 fw-normal"
                    >
                      Change Driver
                    </Button>
                  ) : null}
                </Col>
              </Row>
              <div className=" mb-2">
                <p className="mb-1 fs-9 text-600">Challan No :</p>
                <Form.Group controlId="challanNo" className="position-relative">
                  <Form.Control
                    name="challanNo"
                    disabled={hideNumber}
                    ref={challanRef}
                    className="w-100"
                    type="text"
                    // value={defaultData?.challan_no?.value || 'KTL202404140033'}
                    isInvalid={touched.challanNo && errors.challanNo}
                    value={values.challanNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  ></Form.Control>
                  <Form.Control.Feedback
                    style={{ borderRadius: '0.25rem' }}
                    type="invalid"
                    tooltip
                  >
                    {errors.challanNo}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className="mb-2">
                <p className="mb-1 fs-9  text-600">Driver UPI Id :</p>
                <Form.Group className="w-100" controlId="upiNumber">
                  <InputGroup className="">
                    <FormControl
                      name="upiNumber"
                      value={values.upiNumber}
                      onChange={handleChange}
                      isInvalid={values.upiNumber?.length === 0}
                      onBlur={handleBlur}
                      disabled={true}
                      ref={upiRef}
                      placeholder="Enter UPI Number"
                      aria-label="voucher"
                    />
                    <Form.Control.Feedback
                      style={{ borderRadius: '0.25rem' }}
                      type="invalid"
                      tooltip
                    >
                      {errors.upiNumber}
                    </Form.Control.Feedback>
                    {values.upiNumber?.length > 0 ? (
                      <LoadingButton
                        idClass={'upiNumber'}
                        size="sm"
                        disabled={values.upiNumber?.length === 0}
                        variant={`${
                          upiVerified ? 'success' : 'phoenix-primary'
                        }`}
                        onClick={verifyUpi}
                        className="px-5"
                        style={{ pointerEvents: upiVerified ? 'none' : 'all' }}
                        primaryText={upiVerified ? 'Verified' : 'Verify'}
                        loadingText={'Verifying...'}
                        isLoading={upiLoading}
                      />
                    ) : (
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={() => setQrOpen(true)}
                        startIcon={
                          <Icon
                            icon={'streamline:qr-code'}
                            className="mb-1"
                            fontSize="14px"
                          />
                        }
                      >
                        Scan QR
                      </Button>
                    )}
                  </InputGroup>
                </Form.Group>
              </div>
              <div className="mb-2">
                <p className="mb-1 fs-9  text-600">Driver UPI Name :</p>
                <Form.Group className="w-100" controlId="upiName">
                  <InputGroup>
                    <FormControl
                      disabled
                      name="upiName"
                      value={values.upiName}
                      placeholder="Driver UPI Name"
                      aria-label="voucher"
                    />
                    {isDifferentName ? (
                      <IconButton
                        size="sm"
                        variant="warning"
                        className="position-relative overflow-hidden"
                        icon={'fluent:warning-20-regular'}
                      />
                    ) : null}
                  </InputGroup>
                </Form.Group>
                {isDifferentName ? (
                  <small className="text-warning fs-10">
                    UPI name is different from driver name
                  </small>
                ) : null}
              </div>
              <div>
                <p className="mb-1 fs-9  text-600">Amount to pay :</p>
                <Form.Group
                  controlId="amount"
                  className="position-relative w-100"
                >
                  {/* <InputGroup.Text id="basic-addon1">Rs.</InputGroup.Text> */}
                  <FormControl
                    placeholder="₹"
                    disabled={
                      !showDriver || errors.challanNo || !amountIsEditable
                    }
                    aria-label="Amount"
                    className="fw-bolder w-100"
                    type="number"
                    ref={amtRef}
                    name="amount"
                    value={values.amount || 0}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.amount && errors.amount}
                  />
                  <Form.Control.Feedback
                    style={{ borderRadius: '0.25rem' }}
                    type="invalid"
                    tooltip
                  >
                    {errors.amount}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>
          </Collapse>

          <div className="">
            <Button
              className="w-100"
              disabled={errors.amount || !upiVerified || values.amount < 1}
              variant="primary"
              onClick={() => handlePinModal('Upi')}
              endIcon={
                <FontAwesomeIcon icon={faChevronRight} className="ms-1 fs-10" />
              }
            >
              Pay via UPI
            </Button>
            <Button
              className="p-0 text-decoration-underline fw-normal"
              disabled={errors.amount}
              variant="link"
              onClick={() => handlePinModal('Cash')}
              endIcon={
                <FontAwesomeIcon icon={faChevronRight} className="ms-1 fs-10" />
              }
            >
              or continue with cash
            </Button>
          </div>
        </Card.Body>
      </Card>
      <PaymentPinModal
        resetData={resetData}
        isDifferentName={isDifferentName}
        proceedPayment={proceedPayment}
        show={showPin}
        amount={values.amount}
        receiverName={values?.upiName}
        driverName={values?.driver_name}
        handleClose={handleClosePinModal}
        paymentMode={payMode}
        paymentCallback={paymentCallback}
      />
      <ScanQrCodeModal
        setUPIData={setUPIData}
        show={openQr}
        handleClose={() => setQrOpen(false)}
        driverName={values?.driver_name}
      />
      <CustomAlert
        show={showTruckError}
        handleClose={() => setShowTruckError(false)}
        message={'Vehicle not found'}
      />

      {openChangeDriver ? (
        <ChangeDriverForChallans
          refreshData={refreshData}
          reFetchChallanData={reFetchChallanData}
          show={openChangeDriver}
          handleClose={() => setOpenChangeDriver(false)}
          data={defaultData}
          transFor={transFor}
        />
      ) : null}
    </>
  );
};

export default QuickPaymentView;
